import React, { useEffect, useState } from "react";
import "./style.scss";
import CompanyLogo from "../../../assets/images/companyLogo.png";
import AuthFrame from "../../../components/Auth/AuthFrame";
import SigninForm from "../../../components/Auth/SigninForm";
// import { useSelector } from "react-redux";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import { setTheme } from "../../../store/actions";
import { useDispatch } from "react-redux";
function Signin() {
  const [errormodalOpen, setErrorModalOpen] = useState(false);
  // const [msg, setMsg] = useState("");
  // const { theme } = useSelector((state) => state.theme);
  // useEffect(() => {
  //   document.body.classList["value"] === "" &&
  //     (document.body.classList = theme);
  // }, [theme]);
  // const authState = useSelector((state) => state.auth);
  // useEffect(() => {
  //   setMsg(authState.message);
  //   setErrorModalOpen(authState.error);

  // }, [authState]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTheme("light"));
  }, []);
  return (
    <div className="signin-container">
      {errormodalOpen && (
        <ErrorModal
          setModalOpen={setErrorModalOpen}
          // desc={msg}
          btnText="Close"
        />
      )}
      <div className="signin-left-wrapper">
        <div className="signin-left">
          <SigninForm />
        </div>
      </div>
      <div className="signin-right">
        <AuthFrame />
      </div>
    </div>
  );
}

export default Signin;
